export default "__VITE_ASSET__PBdTb7Kz__"